












import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ProsemirrorHelper } from '../../helpers/prosemirror.helper';
import type { IField } from '../../types';

@Component({
  data: () => ({
    ProsemirrorHelper,
  }),
})
export default class PricingTableCheckbox extends Vue {
  @Prop() input: IField;
  @Prop({ default: false }) disabled: boolean;

  get inputId(): string {
    return this.input?.id;
  }

  get inputValue(): string {
    return this.input?.value;
  }

  handleUpdateChecked(checked: boolean) {
    this.$emit(
      'update-checked',
      { ...this.input, value: checked ? '1' : '0' },
      'optionalProductFieldId'
    );
  }
}
